import { MarketPlaceLinksList, MarketPlaceListItem, MarketPlaceLinkItem } from './styles';
import { useTranslatedObject } from '../../utils/translation';
import { FooterNavigationBar, sendGA4Data } from '../../analytics/events';

const Contact = ({ onContactUsClick = () => {} }) => {
  const footer = useTranslatedObject('footer');

  const handleClick = (label, e) => {
    if (label === "Contact us") {
      e.preventDefault();
      onContactUsClick();
    }
    sendGA4Data(FooterNavigationBar, { eventCategory: "Contact & Connect", eventLabel: label });
  };

  return (
    <MarketPlaceLinksList id="contact-list">
      {footer?.contact_links?.map(({ label, url }) => (
        <MarketPlaceListItem id={`contact-list-item-${label}`} key={label}>
          <MarketPlaceLinkItem
            id={`contact-link-item-${label}`}
            aria-label={label}
            href={url}
            target="_blank"
            onClick={(e) => handleClick(label, e)}
          >
            {label}
          </MarketPlaceLinkItem>
        </MarketPlaceListItem>
      ))}
    </MarketPlaceLinksList>
  );
};

export default Contact;